<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <b-row>
            <b-col cols="2">
              <b-form-group label="Sipariş Çek" label-for="item-name">
                <v-select
                  v-model="Merb"
                  :options="tabmenus"
                  label="name"
                  style=""
                  @input="siparisCek(0)"
                >
                  <template slot="option" slot-scope="option">
                    <div class="option-inline">
                      <img
                        v-if="mpControl(option.name)"
                        :src="require('../../assets/images/logo/' + option.name.trim() + '.png')"
                        width="28"
                        class="option-icon"
                      />
                      <span>{{ option.name }}</span>
                    </div>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Ara..." label-for="item-name">
                <b-form-input
                  v-model="arananDeger"
                  id="smallInput"
                  @keyup.enter="siparisListesi"
                />
              </b-form-group>
            </b-col>
            <b-col cols="1">
              <b-form-group label="Filtre Türü" label-for="item-name">
                <v-select
                  v-model="secilenDurum"
                  :options="durumlist"
                  label="name"
                  style=""
                >
                </v-select>
              </b-form-group>
            </b-col>
            <b-col cols="5" class="justify-items-end">
              <div class="demo-alignment">
                <vs-button style="border-radius: 5px" type="gradient" @click="siparisListesi()">
                  Yeni Siparişler
                </vs-button>
                <vs-button
                  style="border-radius: 5px"
                  type="gradient"
                  color="#02a66d"
                  gradient-color-secondary="rgb(1, 52, 74)"
                  @click="tamamlananSiparis()"
                >
                  Tamamlanan Siparişler
                </vs-button>
              </div>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Toplu İşlemler" label-for="item-name">
                <v-select
                  v-model="bulkAction"
                  :options="bulkList"
                  label="name"
                  style=""
                  @input="runBulkAction"
                >
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <vs-progress :percent="progress" v-model="progress" color="primary" />
        </vx-card>
        <vx-card title=""></vx-card>
      </div>

      <div class="vx-col lg:w-4/4 w-full relative">
        <vs-table :data="list" :hidden="validated" :key="sayfaListe">
          <template slot="thead">
            <vs-th style="width: 40px"></vs-th>
            <vs-th sort-key="orderNumber">Sipariş Bilgileri</vs-th>
            <vs-th sort-key="customerFullName">Alıcı</vs-th>
            <vs-th sort-key="productName">Bilgiler</vs-th>
            <vs-th sort-key="Total">Fiyat</vs-th>
            <vs-th sort-key="cargoProviderName">Kargo</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <vs-checkbox
                  v-model="seciliSiparisler"
                  :vs-value="data[indextr]"
                  :title="data[indextr].orderNumber"
                />
              </vs-td>

              <vs-td :data="data[indextr].orderNumber">
                <div class="font-semibold text-primary">
                  #{{ data[indextr].orderNumber }}
                </div>
                <div class="text-sm">
                  {{ formatDate(data[indextr].orderDate) }}
                  {{ formatTime(data[indextr].orderDate) }}
                </div>
                <div class="flex items-center">
                  <img
                    v-if="getMarketplaceLogo(data[indextr].MarketPlaceName)"
                    :src="getMarketplaceLogo(data[indextr].MarketPlaceName)"
                    :alt="data[indextr].MarketPlaceName"
                    width="40"
                  />
                </div>
              </vs-td>

              <vs-td :data="data[indextr].customerFullName">
                <div class="font-medium">
                  {{ data[indextr].customerFullName }}
                </div>
                <div v-if="data[indextr].customerPhone" class="text-xs">
                  {{ data[indextr].customerPhone }}
                </div>
              </vs-td>

              <vs-td>
                <div
                  v-if="data[indextr].Products && data[indextr].Products.length"
                >
                  <div
                    v-for="(product, pIndex) in data[indextr].Products"
                    :key="pIndex"
                    class="mb-1 pb-1 border-b last:border-b-0"
                  >
                    <div class="font-medium text-sm">
                      {{ product.productName }}
                    </div>
                    <div v-if="product.sku" class="text-xs text-gray-500">
                      SKU: {{ product.sku }}
                    </div>
                    <div v-if="product.barcode" class="text-xs text-gray-500">
                      Barkod: {{ product.barcode }}
                    </div>
                    <div v-if="product.price" class="text-xs">
                      Fiyat: {{ formatCurrency(product.price) }}
                    </div>
                  </div>
                </div>
                <span v-else class="text-gray-400">-</span>
              </vs-td>

              <vs-td :data="data[indextr].Total">
                <div class="font-semibold">
                  {{ formatCurrency(data[indextr].Total) }}
                </div>
              </vs-td>

              <vs-td :data="data[indextr].cargoProviderName">
                <div class="flex items-center">
                  <img
                    :src="getCargoLogo(data[indextr].cargoProviderName)"
                    :alt="data[indextr].cargoProviderName"
                    width="60"
                    class="mr-2"
                  />
                </div>
                <div v-if="data[indextr].cargoTrackingNumber">
                  <div class="font-semibold">
                    {{ data[indextr].cargoTrackingNumber }}
                  </div>
                </div>
                <span v-else class="text-gray-400">-</span>

                <vs-button
                  type="border"
                  size="small"
                  icon="print"
                  @click="openLabelDialogSingle(data[indextr])"
                  class="mb-1"
                >
                  Kargo Etiketi
                </vs-button>
              </vs-td>
            </vs-tr>

            <vs-td colspan="4" style="text-align: right">Toplam : </vs-td>
            <vs-td>{{ toplamParca }} Parça</vs-td>
          </template>
        </vs-table>

        <div class="con-pagination-table vs-table--pagination">
          <div class="vs-row" style="justify-content: space-between; display: flex; width: 100%">
            <div
              class="vs-col vs-pagination--mb vs-xs-12 vs-sm-12 vs-lg-6"
              style="justify-content: flex-start; display: flex; align-items: center; margin-left: 0%; width: 100%"
            ></div>
            <div
              class="vs-col vs-pagination--mb vs-xs-12 vs-sm-12 vs-lg-6"
              style="justify-content: flex-end; display: flex; align-items: center; margin-left: 0%; width: 100%"
            >
              <div class="con-vs-pagination vs-pagination-primary">
                <nav class="vs-pagination--nav">
                  <button
                    class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
                    @click="sayfaGeri()"
                  >
                    <i class="vs-icon notranslate icon-scale material-icons null">chevron_left</i>
                  </button>
                  <ul class="vs-pagination--ul"></ul>
                  <button
                    class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
                    @click="sayfaIleri()"
                  >
                    <i class="vs-icon notranslate icon-scale material-icons null">chevron_right</i>
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vs-popup title="Kargo Etiketi Yazdır" :active.sync="showLabelDialog" :close-icon="true">
      <div v-if="labelOrders && labelOrders.length" ref="labelPrintArea">
        <div class="flex justify-end mb-2">
          <vs-button type="filled" color="success" size="small" class="no-print" @click="printCurrentLabel">Çıktı Al</vs-button>
        </div>
        <div
          v-for="(orderItem, orderIdx) in labelOrders"
          :key="orderItem.orderNumber || orderItem.cargoTrackingNumber || orderIdx"
          class="label-order"
        >
          <div class="label-logo-row">
            <img
              v-if="getMarketplaceLogo(orderItem.MarketPlaceName)"
              :src="getMarketplaceLogo(orderItem.MarketPlaceName)"
              height="60px"
            />
            <img
              v-if="getCargoLogo(orderItem.cargoProviderName)"
              :src="getCargoLogo(orderItem.cargoProviderName)"
              height="60px"
            />
          </div>
          <div class="label-grid">
            <div class="label-card">
              <h5 class="font-bold mb-4">Alıcı Bilgileri</h5>
              <p><strong>Sipariş No:</strong> {{ orderItem.orderNumber || "-" }}</p>
              <p><strong>Ad-Soyad:</strong> {{ orderItem.customerFullName || "-" }}</p>
              <p>
                <strong>Adres:</strong>
                {{ orderItem.ShipmentFullAddress || "-" }}
              </p>
              <p v-if="orderItem.customerPhone"><strong>Telefon:</strong> {{ orderItem.customerPhone }}</p>
            </div>
            <div class="label-card">
              <h5 class="font-bold mb-4">Kargo Barkodu</h5>
              <div
                v-if="orderItem.cargoTrackingNumber"
                class="barcode-box"
              >
                <v-barcode
                  :value="orderItem.cargoTrackingNumber"
                  format="CODE128"
                  :width="2"
                  :height="70"
                  :font-size="14"
                  line-color="#000000"
                  background="transparent"
                >
                  Barkod oluşturulamadı
                </v-barcode>
              </div>
              <div v-else class="text-gray-400">-</div>
            </div>
          </div>
          <div class="label-card">
            <h5 class="font-bold mb-4">Ürün Bilgileri</h5>
            <div
              v-for="(product, idx) in (orderItem.Products || [])"
              :key="idx"
              class="label-product-row"
            >
              <div class="font-semibold mb-1">{{ product.productName }}</div>
              <div class="label-product-meta">
                <span v-if="product.quantity"><strong>Adet:</strong> {{ product.quantity }}</span>
                <span v-if="product.color"><strong>Renk:</strong> {{ product.color }}</span>
                <span v-if="product.size"><strong>Ebat:</strong> {{ product.size }}</span>
                <span v-if="product.barcode"><strong>Barkod:</strong> {{ product.barcode }}</span>
                <span v-if="product.sku"><strong>Stok Kodu:</strong> {{ product.sku }}</span>
              </div>
            </div>
            <div v-if="!(orderItem.Products && orderItem.Products.length)" class="text-gray-400 text-xs">
              Ürün bilgisi bulunamadı.
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import state from "../../store/state";
import Store from "../../store/store";
import vSelect from "vue-select";
import VueBarcode from "vue-barcode";
import { fixTurkishCharsDeep } from "../../helpers/fixTurkishChars";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

export default {
  data() {
    return {
      arananDeger: "",
      list: [],
      showLabelDialog: false,
      labelOrders: [],
      tamamlananList: [],
      tamamlananValidated: true,
      progress: 0,
      sayfaListe: 0,
      toplamSayfa: 0,
      toplamParca: 0,
      validated: true,
      validated1: true,
      Merb: null,
      tabmenus: null,
      seciliSiparisler: [],
      isCompletedView: false,
      durumlist: [
        { name: "Tümü", val: "all" },
        { name: "Tekli", val: "tekli" },
        { name: "Çoklu", val: "coklu" },
      ],
      secilenDurum: "",
      bulkAction: "",
      bulkList: [
        { name: "Toplu Sipariş Tamamla" },
        { name: "Kargo Etiketi Yazdır" },
        { name: "Seçilen Siparişleri Çıktı Al" },
      ],
    };
  },
  components: {
    "v-select": vSelect,
    "v-barcode": VueBarcode,
  },
  methods: {
    tamamlananSiparis() {
      const vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      this.isCompletedView = true;
      this.validated = false;
      const selectedFilter =
        this.secilenDurum && this.secilenDurum.val ? this.secilenDurum.val : "all";
      const args = {
        searchText:
          this.arananDeger && this.arananDeger.trim() !== ""
            ? this.arananDeger
            : null,
        filterType: selectedFilter,
        page: String(this.sayfaListe),
        pageSize: "50",
        token: Store.state.tokenId,
      };
      soap.createClient(url, function(err, client) {
        if (err) {
          vs.notify({
            text: "Tamamlanan siparişler listelenemedi.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
          });
          return;
        }
        client.GetOrdersSummaryCompleted(args, function(err, result) {
          if (err) {
            vs.notify({
              text: "Tamamlanan siparişler listelenemedi.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
            return;
          }
          if (result.GetOrdersSummaryCompletedResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            const responseJson = result.GetOrdersSummaryCompletedResult || "[]";
            vm.veriler = JSON.parse(responseJson);
            vm.toplamSayfa =
              vm.veriler &&
              vm.veriler[0] &&
              vm.veriler[0]["toplamKayitSayisi"]
                ? vm.veriler[0]["toplamKayitSayisi"]
                : 0;
            vm.list = Array.isArray(vm.veriler) ? [...vm.veriler] : [];
          } catch (error) {
            vs.notify({
              text: "Tamamlanan siparişler listelenirken hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    siparisCek(sayfasayisi) {
      const vs = this.$vs;
      const vm = this;
      const args = {
        pazaryeri: vm.Merb ? vm.Merb.name : null,
        siparisDurumu: 0,
        listelenecekSayfa: sayfasayisi,
        token: Store.state.tokenId,
      };

      const soap = require("soap");
      const url = state.sistemAddress;

      soap.createClient(url, function(err, client) {
        client.pazaryeriSiparisCek(args, function(err, result) {
          if (result.pazaryeriSiparisCekResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.pazaryeriSiparisCekResult));
            if (vm.veriler.response == "Ok") {
              if (parseInt(vm.veriler.page) < parseInt(vm.veriler.totalPages)) {
                vm.veriler.page = parseInt(vm.veriler.page) + 1;
                const percent = 100 / parseInt(vm.veriler.totalPages);
                vm.progress = percent * vm.veriler.page;
                vm.siparisCek(vm.veriler.page);
              } else {
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
                vs.notify({
                  text: "Siparişler çekildi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
              }
            } else {
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              vs.notify({
                text: "Siparişler çekildi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            }
          } catch (error) {
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            vs.notify({
              text: "Hata oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    sayfaIleri() {
      this.sayfaListe = this.sayfaListe + 1;
      if (this.toplamSayfa > 0 && this.sayfaListe > this.toplamSayfa) {
        this.sayfaListe = this.toplamSayfa;
      }
      if (this.isCompletedView) {
        this.tamamlananSiparis();
      } else {
        this.siparisListesi();
      }
    },
    sayfaGeri() {
      this.sayfaListe = this.sayfaListe - 1;
      if (this.sayfaListe < 0) {
        this.sayfaListe = 0;
      }
      if (this.isCompletedView) {
        this.tamamlananSiparis();
      } else {
        this.siparisListesi();
      }
    },
    siparisListesi() {
      this.isCompletedView = false;
      this.tamamlananValidated = true;
      this.validated1 = true;
      this.validated = false;
      const vm = this;
      const vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      const selectedFilter =
        this.secilenDurum && this.secilenDurum.val ? this.secilenDurum.val : "all";
      const args = {
        searchText:
          this.arananDeger && this.arananDeger.trim() !== ""
            ? this.arananDeger
            : null,
        filterType: selectedFilter,
        page: String(this.sayfaListe),
        pageSize: "50",
        token: Store.state.tokenId,
      };
      soap.createClient(url, function(err, client) {
        client.GetOrdersSummary2(args, function(err, result) {
          if (result.GetOrdersSummary2Result == "-1") {
            Store.dispatch("logout");
          }
          try {
            const responseJson = result.GetOrdersSummary2Result || "[]";
            vm.veriler = JSON.parse(responseJson);
            vm.toplamSayfa =
              vm.veriler &&
              vm.veriler[0] &&
              vm.veriler[0]["toplamKayitSayisi"]
                ? vm.veriler[0]["toplamKayitSayisi"]
                : 0;
            vm.list = Array.isArray(vm.veriler) ? [...vm.veriler] : [];
          } catch (error) {
            vs.notify({
              text: "Siparişler listelenirken hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    mpControl(e) {
      if (!e) return false;
      const lower = e.toLowerCase();
      if (
        lower.includes("toplu") ||
        lower.includes("flip") ||
        lower.includes("php") ||
        lower.includes("tum") ||
        lower.includes("tüm")
      ) {
        return false;
      }
      return true;
    },
    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleDateString("tr-TR");
    },
    formatTime(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
    },
    formatCurrency(amount) {
      if (!amount) return "₺0,00";
      const num = parseFloat(amount);
      return new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(num);
    },
    getMarketplaceLogo(marketplaceName) {
      if (!marketplaceName) return null;
      try {
        return require("../../assets/images/logo/" + marketplaceName.trim() + ".png");
      } catch {
        return null;
      }
    },
    getCargoLogo(cargoName) {
      if (!cargoName) return null;
      const lower = cargoName.toLowerCase().trim();

      const aliasMap = {
        "trendyol express marketplace": "trendyol-express",
        "aras kargo marketplace": "aras",
        "aras kargo": "aras",
        "aras": "aras",
        "ptt kargo": "ptt",
        "ptt": "ptt",
        "sürat kargo marketplace": "surat",
        "yurtiçi kargo marketplace": "yurtici",
        "yurtiçi kargo": "yurtici",
        "mng": "mng",
        "hepsijet": "hepsijet",
        "dhl ecommerce marketplace": "dhl",
        "dhl ecommerce": "dhl",
        "kargonomi": "kargonomi",
      };
      const alias = aliasMap[lower];

      const slug = lower.replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
      const candidates = [];
      if (alias) candidates.push(alias);
      candidates.push(slug);
      candidates.push(lower.replace(/\s+/g, "").replace(/-/g, ""));
      candidates.push(cargoName.trim());

      for (const name of candidates) {
        try {
          return require("../../assets/images/logo/" + name + ".png");
        } catch {
          // continue
        }
      }
      return null;
    },
    runBulkAction(action) {
      const selectedAction = action || this.bulkAction;
      if (selectedAction && Object.prototype.hasOwnProperty.call(selectedAction, "val")) {
        this.siparisListesi();
        return;
      }

      if (!selectedAction || !selectedAction.name) {
        return;
      }

      if (
        selectedAction.name === "Seçilen Siparişleri Çıktı Al") {
        this.printSelectedOrders();
        return;
      }

      if (selectedAction.name === "Toplu Sipariş Tamamla") {
        this.completeSelectedOrders();
      } else if (selectedAction.name === "Kargo Etiketi Yazdır") {
        this.openLabelDialog();
      }
    },
    openLabelDialog() {
      const vs = this.$vs;
      const selectedOrders = (this.seciliSiparisler || []).filter(Boolean);
      if (!selectedOrders.length) {
        vs.notify({
          text: "Lütfen etiket oluşturmak için en az bir sipariş seçin.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
        this.bulkAction = "";
        return;
      }
      this.labelOrders = this.uniqueOrders(selectedOrders);
      this.showLabelDialog = true;
    },
    openLabelDialogSingle(order) {
      this.labelOrders = order ? this.uniqueOrders([order]) : [];
      this.showLabelDialog = true;
    },
    printCurrentLabel() {
      const wrapper = this.$refs.labelPrintArea;
      if (!wrapper) {
        window.print();
        return;
      }
      const printContents = wrapper.innerHTML;
      const popupWin = window.open("", "_blank", "width=900,height=1000");
      if (!popupWin) return;

      popupWin.document.open();
      popupWin.document.write(`
        <html>
          <head>
            <title>Kargo Etiketi</title>
            <style>
              @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
              body { font-family: Arial, sans-serif; margin: 16px; }
              .label-grid { display: grid; grid-template-columns: 2fr 1fr; gap: 12px; }
              .label-card { border: 1px solid #e0e0e0; border-radius: 8px; padding: 12px; margin-bottom: 15px; }
              .label-product-row { padding: 8px 0; border-bottom: 1px solid #f0f0f0; }
              .label-product-row:last-child { border-bottom: none; }
              .barcode-box { display: flex; align-items: center; justify-content: center; padding: 12px 10px; border: 1px dashed #dcdcdc; border-radius: 8px; background: #fff; }
              .label-order { margin-bottom: 18px; border-bottom: 1px solid #f0f0f0; padding-bottom: 12px; }
              .label-logo-row { display: flex; justify-content: space-between; align-items: center; gap: 16px; margin-bottom: 18px; }
              .label-logo-row img { max-height: 60px; object-fit: contain; }
              .no-print { display: none !important; }
            </style>
          </head>
          <body onload="window.print(); window.close();">
            ${printContents}
          </body>
        </html>
      `);
      popupWin.document.close();
    },
    printSelectedOrders() {
      const vs = this.$vs;
      const selectedOrders = this.uniqueOrders((this.seciliSiparisler || []).filter(Boolean));
      if (!selectedOrders.length) {
        vs.notify({
          text: "Lütfen yazdırmak için en az bir sipariş seçin.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
        this.bulkAction = "";
        return;
      }

      const popupWin = window.open("", "_blank", "width=900,height=1000");
      if (!popupWin) {
        vs.notify({
          text: "Yazdırma penceresi açılamadı. Tarayıcı engelini kontrol edin.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
        return;
      }

      const now = new Date();
      const dateLabel = `${this.formatDate(now)} ${this.formatTime(now)}`;
      const rowsHtml =
        selectedOrders.map((order) => this.buildPrintTableRow(order)).join("") ||
        `<tr><td class="cell" colspan="5">Seçili sipariş bulunamadı.</td></tr>`;

      popupWin.document.open();
      popupWin.document.write(`
        <html>
          <head>
            <title>Seçilen Siparişler</title>
            <style>
              @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
              body { font-family: Arial, sans-serif; padding: 18px; color: #111; }
              .header-line { display: flex; justify-content: space-between; font-size: 12px; margin-bottom: 6px; }
              .print-title { text-align: center; font-weight: 700; margin: 6px 0 18px; font-size: 18px; }
              .print-table { width: 100%; border-collapse: collapse; font-size: 12px; }
              .print-table th { background: #f5f5f5; font-weight: 700; text-align: left; }
              .print-table th, .print-table td { border: 1px solid #ccc; padding: 8px; vertical-align: top; }
              .product-line { margin-bottom: 6px; }
              .product-title { font-weight: 600; }
              .product-meta { color: #444; }
              .text-muted { color: #777; }
              .strong { font-weight: 700; }
            </style>
          </head>
          <body onload="window.print(); window.close();">
            <div class="header-line">
              <span>${this.escapeHtml(dateLabel)}</span>
              <span>Seçilen Siparişler</span>
            </div>
            <div class="print-title">Seçilen Siparişler Listesi</div>
            <table class="print-table">
              <thead>
                <tr>
                  <th>Sipariş No</th>
                  <th>Alıcı</th>
                  <th>Ürünler</th>
                  <th>Kargo Firması</th>
                  <th>Takip No</th>
                </tr>
              </thead>
              <tbody>${rowsHtml}</tbody>
            </table>
          </body>
        </html>
      `);
      popupWin.document.close();
      this.bulkAction = "";
    },
    buildPrintTableRow(order) {
      const orderNo = order && order.orderNumber ? `#${this.escapeHtml(order.orderNumber)}` : "-";
      const buyer = this.escapeHtml((order && order.customerFullName) || "-");
      const cargo = this.escapeHtml((order && order.cargoProviderName) || "-");
      const tracking = this.escapeHtml((order && order.cargoTrackingNumber) || "-");
      const productsHtml = this.formatProductsForPrint(order && order.Products);

      return `
        <tr>
          <td class="cell strong">${orderNo}</td>
          <td class="cell">${buyer}</td>
          <td class="cell">${productsHtml}</td>
          <td class="cell">${cargo}</td>
          <td class="cell">${tracking}</td>
        </tr>
      `;
    },
    formatProductsForPrint(products) {
      if (!(products && products.length)) {
        return `<span class="text-muted">-</span>`;
      }
      return products
        .map((product) => {
          const name = this.escapeHtml(product && product.productName ? product.productName : "-");
          const metaParts = [];
          if (product && product.quantity) metaParts.push(`Adet: ${this.escapeHtml(product.quantity)}`);
          if (product && product.size) metaParts.push(`Ebat: ${this.escapeHtml(product.size)}`);
          if (product && product.color) metaParts.push(`Renk: ${this.escapeHtml(product.color)}`);
          if (product && product.barcode) metaParts.push(`Barkod: ${this.escapeHtml(product.barcode)}`);
          if (product && product.sku) metaParts.push(`Stok Kodu: ${this.escapeHtml(product.sku)}`);
          const meta = metaParts.length ? `<div class="product-meta">${metaParts.join(" | ")}</div>` : "";
          return `<div class="product-line"><div class="product-title">${name}</div>${meta}</div>`;
        })
        .join("");
    },
    escapeHtml(value) {
      if (value === null || value === undefined) return "";
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    uniqueOrders(orderList) {
      const seen = new Set();
      const cleaned = [];
      (orderList || []).forEach((order) => {
        if (!order) return;
        const key = order.orderNumber || order.cargoTrackingNumber || JSON.stringify(order);
        if (seen.has(key)) return;
        seen.add(key);
        cleaned.push(order);
      });
      return cleaned;
    },
    completeSelectedOrders() {
      const vs = this.$vs;
      const selectedOrders = (this.seciliSiparisler || [])
        .map((order) => order && order.orderNumber)
        .filter(Boolean);

      if (!selectedOrders.length) {
        vs.notify({
          text: "Lütfen tamamlamak için en az bir sipariş seçin.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
        this.bulkAction = "";
        return;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Onay",
        text: "Seçili siparişler tamamlandı olarak işaretlensin mi?",
        acceptText: "Evet",
        cancelText: "Vazgeç",
        accept: () => this.sendCompleteOrders(selectedOrders),
        cancel: () => {
          this.bulkAction = "";
        },
      });
    },
    sendCompleteOrders(selectedOrders) {
      const vs = this.$vs;

      const orderNumbersCsv  =  selectedOrders.join(",");
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        orderNumbersCsv ,
        token: Store.state.tokenId,
      };
      const vm = this;

      soap.createClient(url, function(err, client) {
        if (err) {
          vs.notify({
            text: "Toplu tamamla servisine ulaşılamadı.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
          });
          return;
        }

        client.CompleteOrders(args, function(err, result) {
          if (err) {
            vs.notify({
              text: "Toplu tamamlama işleminde hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
            return;
          }

          if (result.CompleteOrdersResult === "-1") {
            Store.dispatch("logout");
            return;
          }

          let response;
          try {
            response = fixTurkishCharsDeep(JSON.parse(result.CompleteOrdersResult));
          } catch (parseError) {
            response = result.CompleteOrdersResult;
          }

          const isSuccess =
            (response && response.isSuccess === true) ||
            (response && response.response === "Ok") ||
            (response && response.status === "Ok") ||
            response === "Ok";

          if (isSuccess) {
            vs.notify({
              text: (response && response.message) || "Seçilen siparişler tamamlandı.",
              iconPack: "feather",
              icon: "icon-check",
              color: "success",
              position: "top-center",
            });
            vm.bulkAction = "";
            vm.seciliSiparisler = [];
            vm.siparisListesi();
          } else {
            vs.notify({
              text: "Toplu tamamlama işlemi başarısız.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
  },

  mounted() {
    this.siparisListesi();
  },
  watch: {
    list: {
      handler: function() {
        this.toplamParca = this.list.reduce((sum, item) => {
          const adet =
            item.SiparisAdetleri !== undefined ? item.SiparisAdetleri : item.siparisAdetleri;
          const parsed = Number(adet);
          return sum + (isNaN(parsed) ? 0 : parsed);
        }, 0);
      },
      deep: true,
    },
  },
  created() {
    this.tabmenus = [];
    this.tabmenus.push({ name: "Tümü" });
    const moduller = JSON.parse(Store.state.moduller);
    moduller.forEach((val) => {
      this.tabmenus.push({ name: val.marketplace });
    });
  },
};
</script>

<style lang="scss">
.vs-table {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.vs-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
  padding: 12px 8px;
}

.vs-table td {
  padding: 10px 8px;
  vertical-align: top;
}

.font-semibold {
  font-weight: 600;
}

.text-xs {
  font-size: 0.75rem;
}

.text-primary {
  color: #0064fa;
}

.option-inline {
  display: flex;
  align-items: center;
}
.option-icon {
  margin-right: 8px;
  border-radius: 4px;
  background: #fff;
  object-fit: contain;
}

.con-vs-popup .vs-popup {
  width: 900px;
}

.label-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 12px;
}

.label-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 15px;
}

.label-logo-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.label-logo-row img {
  max-height: 60px;
  object-fit: contain;
}

.label-order {
  margin-bottom: 18px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 12px;
}

.label-product-row {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.label-product-row:last-child {
  border-bottom: none;
}

.label-product-meta span {
  margin-right: 10px;
  font-size: 12px;
}

.barcode-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 10px;
  border: 1px dashed #dcdcdc;
  border-radius: 8px;
  background: #fff;
}

.barcode-box svg {
  max-width: 100%;
}

.barcode-box text {
  font-size: 14px;
  letter-spacing: 2px;
}
</style>
